import { createElement } from 'react';
import { string, shape, node, bool, func } from 'prop-types';
import '../types/props.js';
import { css } from 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import Flex from 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import { b as buttonPropTypes } from '../chunk-68945c57.js';
import _omit from 'lodash/omit';
import '../Button/ActionButtons.js';
import '../Button/index.js';
import 'classnames';
import 'reakit/Heading';
import '../Heading/styled.js';
import '../Heading/index.js';
import Icon from '../Icon/index.js';
import '../VisuallyHidden.js';
import '../Text/styled.js';
import Text from '../Text/index.js';
import _Alert from './styled.js';
import AlertClose from './AlertClose.js';
export { default as AlertClose, alertCloseDefaultProps, alertClosePropTypes } from './AlertClose.js';
import AlertTitle from './AlertTitle.js';
export { default as AlertTitle, alertTitlePropTypes } from './AlertTitle.js';
var ContentWrapper = styled(Box).withConfig({
  displayName: "Alert__ContentWrapper",
  componentId: "sc-1e5x83i-0"
})(["padding:", "rem;", ";"], space(4), function (props) {
  return props.hasIcon && css(["padding-left:0;"]);
});
var IconWrapper = styled(Flex).withConfig({
  displayName: "Alert__IconWrapper",
  componentId: "sc-1e5x83i-1"
})(["padding:0 ", "rem;"], space(4));

var Alert = function Alert(_ref) {
  var className = _ref.className,
      closeButtonProps = _ref.closeButtonProps,
      children = _ref.children,
      hasIcon = _ref.hasIcon,
      onClickClose = _ref.onClickClose,
      showCloseButton = _ref.showCloseButton,
      title = _ref.title,
      type = _ref.type,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "closeButtonProps", "children", "hasIcon", "onClickClose", "showCloseButton", "title", "type"]);

  return createElement(_Alert, _extends({
    role: "alert",
    className: className,
    type: type
  }, props), createElement(Flex, {
    alignItems: "center"
  }, hasIcon && type && createElement(IconWrapper, null, createElement(Icon, {
    a11yHidden: true,
    color: type,
    icon: type,
    size: children ? '400' : undefined
  })), createElement(ContentWrapper, {
    hasIcon: hasIcon
  }, title && createElement(AlertTitle, null, title), typeof children === 'string' ? createElement(Text, null, children) : children), showCloseButton && createElement(AlertClose, _extends({
    isAbsolute: Boolean(children),
    onClickClose: onClickClose
  }, closeButtonProps))));
};

var alertPropTypes = {
  className: string,
  closeButtonProps: shape(_omit(buttonPropTypes, 'children')),
  children: node,
  hasIcon: bool,
  hasTint: bool,
  onClickClose: func,
  showCloseButton: bool,
  title: string,
  type: string
};
Alert.propTypes = alertPropTypes;
var alertDefaultProps = {
  className: undefined,
  closeButtonProps: {},
  children: undefined,
  hasIcon: false,
  hasTint: false,
  onClickClose: undefined,
  showCloseButton: false,
  title: undefined,
  type: 'info'
};
Alert.defaultProps = alertDefaultProps;
var C = Alert;
export default C;
export { C as Alert, alertDefaultProps, alertPropTypes };